import React from 'react';
import styled from 'styled-components';

type LogoProps = {
  size: number,
  /** Use the mark intended for a dark surface, e.g. the nav. */
  onDark?: boolean,
};

const LogoStyled = styled.span`
  svg {
    height: 100%;
    width: 100%;
  }
`;

/** Renders the app logo image at the given size. */
export const Logo = (props: LogoProps) => (
  <LogoStyled className="logo" style={{ height: `${props.size}rem`, width: 'auto' }}>
    <img src={props.onDark ? '/images/logo.webp' : '/images/logo_dark_medium.png'} alt="Logo" style={{ height: `${props.size}rem`, width: 'auto' }} />
  </LogoStyled>
);